import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "password-area"
}
const _hoisted_4 = ["placeholder", "type"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "titre-modale" }
const _hoisted_11 = { class: "div-input-modale" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "div-input-modale" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "div-input-modale" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "div-input-modale" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "div-input-modale" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "text-left margin-left-4pct" }
const _hoisted_22 = { class: "italique bold" }
const _hoisted_23 = { class: "italique bold" }
const _hoisted_24 = { class: "italique bold" }
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "titre-formulaire-bleu bold" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "column width-50pct" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "column width-50pct" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "titre-formulaire-bleu bold" }
const _hoisted_39 = {
  href: "https://www.groupeherve.com/cgu.html",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          name: "login",
          placeholder: _ctx.$t('login.identifiant.placeholder'),
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event)),
          required: ""
        }, null, 8, _hoisted_2), [
          [_vModelText, _ctx.login]
        ]),
        (_ctx.oldLogin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                name: "password",
                placeholder: _ctx.$t('login.password.placeholder'),
                type: _ctx.showPassword ? 'text' : 'password',
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["enter"])),
                required: ""
              }, null, 40, _hoisted_4), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("img", {
                src: _ctx.loadEyeIcon,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleShow())),
                alt: "Voir le mot de passe"
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          class: "account",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modaleDemandeCompteOuverte = true))
        }, _toDisplayString(_ctx.$t('login.account.link')), 1),
        _createElementVNode("p", {
          class: "account",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modaleDemandeFournisseurCompteOuverte = true))
        }, _toDisplayString(_ctx.$t('login.account.fournisseur.link')), 1),
        _createElementVNode("button", {
          class: "form-submit-button",
          type: "submit",
          disabled: !_ctx.isComplete
        }, _toDisplayString(_ctx.$t('login.connect')), 9, _hoisted_6)
      ])
    ], 32),
    (_ctx.demandeCompteClientSucces || _ctx.demandeCompteFournisseurSucces)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _ctx.closeModalSuccess
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              "active-validate": true,
              "without-bot-nav": true,
              "header-title": _ctx.$t('demande.compte.envoye.titre.modale'),
              onCancel: _ctx.closeModalSuccess
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.checkBoxIcon,
                  alt: ""
                }, null, 8, _hoisted_7),
                (_ctx.demandeCompteClientSucces)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('demande.compte.client.message.succes')), 1))
                  : _createCommentVNode("", true),
                (_ctx.demandeCompteFournisseurSucces)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('demande.compte.fournisseur.message.succes')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header-title", "onCancel"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.modaleDemandeCompteOuverte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.modaleDemandeCompteOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              "active-validate": _ctx.demandeCompteValide,
              "header-title": _ctx.$t('demande.creation.compte.modal.titre'),
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modaleDemandeCompteOuverte = false)),
              onConfirm: _ctx.creerDemandeDeCompte
            }, {
              default: _withCtx(() => [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('demande.creation.compte.modal.coordonnees')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      name: "nomModale",
                      placeholder: _ctx.$t('demande.creation.compte.modal.nom'),
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nomModale) = $event)),
                      required: "",
                      class: "input-modale"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.nomModale]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      name: "prenomModale",
                      placeholder: _ctx.$t('demande.creation.compte.modal.prenom'),
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.prenomModale) = $event)),
                      required: "",
                      class: "input-modale"
                    }, null, 8, _hoisted_14), [
                      [_vModelText, _ctx.prenomModale]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      name: "emailModale",
                      placeholder: _ctx.$t('demande.creation.compte.modal.mail'),
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.emailModale) = $event)),
                      required: "",
                      class: _normalizeClass(!_ctx.isMailValid ? 'no-valid' : 'input-modale')
                    }, null, 10, _hoisted_16), [
                      [_vModelText, _ctx.emailModale]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      name: "entrepriseModale",
                      placeholder: _ctx.$t('demande.creation.compte.modal.entreprise'),
                      type: "text",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entrepriseModale) = $event)),
                      required: "",
                      class: "input-modale"
                    }, null, 8, _hoisted_18), [
                      [_vModelText, _ctx.entrepriseModale]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      name: "numeroTelephoneModale",
                      placeholder: _ctx.$t('demande.creation.compte.modal.telephone'),
                      maxlength: "10",
                      type: "number",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.numeroTelephoneModale) = $event)),
                      required: "",
                      class: _normalizeClass(!_ctx.isTelephoneValid ? 'no-valid' : 'input-modale')
                    }, null, 10, _hoisted_20), [
                      [_vModelText, _ctx.numeroTelephoneModale]
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["active-validate", "header-title", "onConfirm"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modaleDemandeFournisseurCompteOuverte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onCancel: _cache[26] || (_cache[26] = ($event: any) => (_ctx.modaleDemandeFournisseurCompteOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              "active-validate": _ctx.demandeCompteFournisseurValide,
              "header-title": _ctx.$t('demande.creation.compte.modal.titre'),
              onCancel: _cache[25] || (_cache[25] = ($event: any) => (_ctx.modaleDemandeFournisseurCompteOuverte = false)),
              onConfirm: _ctx.creerDemandeDeCompteFournisseur
            }, {
              default: _withCtx(() => [
                _createElementVNode("form", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('demande.compte.fournisseur.texte.italique')), 1),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", _hoisted_23, _toDisplayString(_ctx.$t('demande.compte.fournisseur.ul.1')), 1),
                    _createElementVNode("li", _hoisted_24, _toDisplayString(_ctx.$t('demande.compte.fournisseur.ul.2')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('demande.compte.fournisseur.texte.gras')), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('demande.compte.fournisseur.form.coordonees')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.societe.nom'),
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.demandeFournisseur.nomSociete) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_29), [
                        [_vModelText, _ctx.demandeFournisseur.nomSociete]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.siren'),
                        type: "text",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.demandeFournisseur.siren) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_30), [
                        [_vModelText, _ctx.demandeFournisseur.siren]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.nom'),
                        type: "text",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.demandeFournisseur.nom) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_31), [
                        [_vModelText, _ctx.demandeFournisseur.nom]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.mail'),
                        type: "text",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.demandeFournisseur.email) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_32), [
                        [_vModelText, _ctx.demandeFournisseur.email]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.ville'),
                        type: "text",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.demandeFournisseur.ville) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_34), [
                        [_vModelText, _ctx.demandeFournisseur.ville]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.civilite'),
                        type: "text",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.demandeFournisseur.civilite) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_35), [
                        [_vModelText, _ctx.demandeFournisseur.civilite]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.prenom'),
                        type: "text",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.demandeFournisseur.prenom) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_36), [
                        [_vModelText, _ctx.demandeFournisseur.prenom]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "nomSociete",
                        placeholder: _ctx.$t('demande.compte.fournisseur.form.placeholder.fonction'),
                        type: "text",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.demandeFournisseur.fonction) = $event)),
                        required: "",
                        class: "input"
                      }, null, 8, _hoisted_37), [
                        [_vModelText, _ctx.demandeFournisseur.fonction]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('demande.compte.fournisseur.form.souhait')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('demande.compte.fournisseur.form.consultation.factures')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.demandeFournisseur.consultationFactures) = $event)),
                    value: true
                  }, null, 512), [
                    [_vModelRadio, _ctx.demandeFournisseur.consultationFactures]
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.$t('yes')) + " ", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.demandeFournisseur.consultationFactures) = $event)),
                    value: false
                  }, null, 512), [
                    [_vModelRadio, _ctx.demandeFournisseur.consultationFactures]
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.$t('no')) + " ", 1),
                  _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.conditionsGeneralesAcceptees) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.conditionsGeneralesAcceptees]
                  ]),
                  _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.$t('demande.compte.fournisseur.form.condition.utilisation')), 1),
                  _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                  _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('demande.compte.fournisseur.form.champs.obligatoires')), 1)
                ])
              ]),
              _: 1
            }, 8, ["active-validate", "header-title", "onConfirm"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}